<template>
    <div class="pa-2" >
        <div class="d-flex">
                
            <v-card
                width="480"
                flat
                outlined
            >
                <v-data-table
                    :headers="headers"
                    :items="table2Records"
                    dense                    
                    fixed-header
                    height="468"
                    disable-pagination
                    hide-default-footer                        
                >
                    <template v-slot:item="{ item }">
                            <SubjectRow
                            v-bind:item="item"
                            v-bind:formLevel="formLevel"
                            v-bind:term="currentTerm"
                            v-bind:maxCourse="maxCourse"
                            v-bind:maxExam="maxExam"
                            v-on:update-average="getAverage"
                        ></SubjectRow>                       
                    </template>
                    
                </v-data-table>
            </v-card >

            <!-- Subjects -->
            <v-card
                width="86"
                flat
                outlined
            >
                <v-data-table
                    :headers="headersSubjects"
                    :items="studentSubjects"
                    dense
                    fixed-header
                    height="350"
                    disable-pagination
                    hide-default-footer
                >
                    <template v-slot:item="{ item }">
                        <tr>
                            <td style="max-width: 1px; white-space: nowrap; overflow:hidden; text-overflow: ellipsis; ">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span
                                            v-bind="attrs"
                                            v-on="on"
                                            :class="classStudentSubjects(item)"
                                        > 
                                            {{ item.abbr}} 
                                        </span>
                                    </template>
                                    <span>{{ item.title}}</span>
                                </v-tooltip>                                   
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
                   
        </div>

        <div class="mt-4 d-flex px-2">
            <div>

                <v-card flat width="470" class="d-flex justify-space-between">
                    
                    <div class="d-flex mb-2 justify-center">
                        <v-btn                        
                            outlined
                            small
                            color="primary"
                            @click="classMarkSheet"
                            
                        >
                            <span style="font-size: 0.6rem" >Class Mark Sheet</span>
                        </v-btn>
                    </div>
                    
                    <div class="d-flex mb-2 justify-center">
                        <v-btn                        
                            outlined
                            small
                            color="primary"
                            @click="rankSheet"
                        >
                            <span style="font-size: 0.6rem">Rank Sheet</span>
                        </v-btn>
                    </div>

                    <div class="d-flex mb-2 justify-center">
                        <v-btn                        
                            outlined
                            small
                            color="primary"
                            @click="enterMarks"
                            :disabled="!editTermReports"
                        >
                            <span style="font-size: 0.6rem">Enter Marks</span>
                        </v-btn>
                    </div>

                    <div class="d-flex mb-2 justify-center">
                        <v-btn                        
                            outlined
                            small
                            color="red"
                            @click="closeEditViewTermReports"
                        >
                            <span style="font-size: 0.6rem">Close Form</span>
                        </v-btn>
                    </div>
    
                </v-card>    
                
                
            </div>
                
            <div class="ml-4 mb-3">
                
            </div>
                
        </div>

        <div class="mt-4 ml-4 px-2">
            <div class="font-weight-bold text-h6">{{ studentRecord.first_name }} {{ studentRecord.last_name }}</div>
            <div class="mt-3">
                <span class="mr-4 "> Average</span>
                <span>{{  getStudentAverage }}</span>
            </div>
        </div>
        

             
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import SubjectRow from './EditViewTermReportsSubjectRow';

export default {
    components: {        
        SubjectRow,
    },
        
    data: () => ({
        headers: [],
        headersSubjects:[],
        
        subjectRecords: [],        
        studentAverage: '',
        studentPasses: null,
        studentDistinctions: '-',
        imageSrc: null,        
        value: ' ', 
        rules: [],
        isValid: true, 
        record: {},
        subjectRecord: [],
        disabled: true,
        displayAverage: false,
        displayGrade: false,
        displayPasses: false,
        displayDistinctions: false,
        formLevel: null,
        btnClass: 'text-caption pa-2  white--text',
        codedComment: null,
        styleFontSize: '0.7rem',
        classes: [],
        newTermBeginningAll: '', 
        
        expand: false, 
        search: null,  
        options: {
            itemsPerPage: -1,
        },
        possibleAttendanceAll: null,
        dialog: false,
        maxCourse: 100,
        maxExam: 100,                  
    }),

    watch: {       
        table2Records: {
            deep: true,
            handler () {                                           
                this.getAverage();
                this.setTableHeaders();
            }
        },

        studentRecord: {
            handler(val){ 
                this.formLevel = val.form_level;
                if(
                    this.formTeacherClass.indexOf(this.studentRecord.class_id) === -1 && 
                    !this.admin &&
                    this.deanFormClasses.indexOf(this.studentRecord.class_id) === -1
                ){
                    //console.log('Not the form Teacher');
                    this.disabled = true;
                }
                else{
                    //console.log('Assigned Form Teacher');
                    this.disabled = false;
                }
                //this.setTableHeaders();
                //console.log(this.selectedFormClass);
            }
        },
        
        formClasses: {
            handler () {
                //this.setFormClasses();
            }
        }
    },

    computed: {
        ...mapGetters({
            sheet: 'termReports/getCommentSheet',
            formTeacherComments: 'termReports/getFormTeacherComments',
            table2Records: 'termReports/getEditViewTermReportsTable2Records',            
            studentRecord: 'termReports/getSelectedStudentRecord',
            formTeacherClass: 'termReports/getFormTeacherClass',
            formClasses: 'termReports/getFormClasses',
            currentTerm: 'termReports/getCurrentTerm',
            currentYear: 'termReports/getCurrentYear',
            pagination: 'termReports/getPagination',
            selectedFormClass: 'termReports/getSelectedFormClass',
            table1Records: 'termReports/getTable1Records',
            studentSubjects: 'termReports/getEditViewTermReportsStudentSubjects',
            admin: 'auth/getAdmin',
            menuOptions: 'admin/getMenuOptions',
            subjectWeightings: 'termReports/getSubjectWeightings',
            deanFormClasses: 'termReports/getDeanFormClasses', 
            editTermReports: 'admin/getEditTermReports', 
            selectedFormLevel: 'termReports/getSelectedFormLevel',
        }),       

        getStudentAverage () {
            return isNaN(this.studentAverage) ? this.studentAverage : this.studentAverage + ' %';
        },
        
        
    },
    methods: {
        ...mapMutations({
            setCommentSheet: 'termReports/setCommentSheet',
            setSaveStatus: 'termReports/setEditViewTermReportsSaveStatus',
            setSaving: 'termReports/setEditViewTermReportsSaving',
            setSaveError: 'termReports/setEditViewTermReportsSaveError',
            setSaved: 'termReports/setEditViewTermReportsSaved',
            setPagination: 'termReports/setPagination',
            overlay: 'termReports/setEditViewTermReportsOverlay',
            loading: 'termReports/setEditViewTermReportsLoading',
            setSelectedStudentRecord: 'termReports/setSelectedStudentRecord',
            setTable2Records: 'termReports/setEditViewTermReportsTable2Records',
            setBottomSheetModel: 'termReports/setBottomSheetModel',
            setBottomSheetTitle: 'termReports/setBottomSheetTitle',
            setExpandTerms: 'termReports/setExpandTerms',
            setSrc: 'termReports/setSrc',
            setEnterMarks: 'termReports/setEnterMarks',
            setEditViewTermReports: 'termReports/setEditViewTermReports',
            setMarkSheetOverlay: 'termReports/setMarkSheetOverlay',            
            setMarkSheetLoading: 'termReports/setMarkSheetLoading',
            setOverlay: 'termReports/setEditViewTermReportsOverlay',
            setExpand: 'termReports/setEditViewTermReportsExpand', 
            setLoading: 'termReports/setEditViewTermReportsLoading', 
            setStudentSubjects: 'termReports/setEditViewTermReportsStudentSubjects', 
            
        }),

        ...mapActions({
            postTable1Record: 'termReports/postTable1Record',
            
            setErrorResponse: 'termReports/setErrorResponse',
            getTable2Records: 'termReports/getTable2Records',
        }),

       getAverage(){
            this.styleFontSize = null;                   
            let recordCount = 0; 
            let totalMarks = 0;
            this.table2Records.forEach(record => {
                recordCount++; 


                if(record.term != 2 ) {
                    totalMarks += (record.exam_mark+record.course_mark)/2;                     
                }
                else if(record.term == 2 && this.studentRecord.form_level <= 4 ) {
                    totalMarks += record.course_mark;                   
                }
                else if(record.term == 2 && this.studentRecord.form_level >= 5) {
                    totalMarks += (record.exam_mark+record.course_mark)/2;
                }
                
            })
            
            //console.log(`Total: ${totalMarks}`);
            if(recordCount != 0 ){               
                this.studentAverage =  (totalMarks / recordCount).toPrecision(3);
            }
            else if(recordCount == 0) this.studentAverage = '--';
           
            
        },
        
        saveTeacherComment(){
            this.updateRecord();
        },

        openBottomSheet(model){
            this.setBottomSheetModel(model); 
            if(model == 'comments'){
                this.setBottomSheetTitle('Form Teacher Comments');
            }
            else{
                this.setBottomSheetTitle('General Remarks: Conduct');
            }
            if(!this.disabled) this.setCommentSheet(true);
        },

        async updateRecord(){
            console.log('updating...');
            this.setSaveStatus('Saving...');
            this.setSaving(true);
            this.setSaved(false);
            this.setSaveError(false);
            //this.studentRecord.lib_comment = this.codedComment.id;           
            //console.log(this.studentRecord);
            try{
                await this.postTable1Record();
                this.setSaveStatus('Record Saved');
                this.setSaving(false);
                this.setSaved(true);
                this.setSaveError(false);
                //console.log(response);
            } catch (error) {
                console.log(error);
                this.setSaveStatus('Error Occured');
                this.setSaving(false);
                this.setSaved(false);
                this.setSaveError(true);
                this.setErrorResponse(error);
            }            
        },

        setTableHeaders () {
            this.headers = [
                {text: 'Code', align: 'center', value: 'subject_id', width: '60', sortable: false},
                {text: 'Subject', align: 'start', value: 'abbr', width: '90', sortable: false},
                {text: 'Course', align: 'start', value: 'course_mark', width: '60', sortable: false},
                {text: 'Exam', align: 'start', value: 'exam_mark', width: '60', sortable: false},
                {text: 'Comment1', align: 'start', value: 'coded_comment', width: '80', sortable: false},
                {text: 'Comment2', align: 'start', value: 'coded_comment_1', width: '80', sortable: false},               
                {text: '', align: 'start', value: 'actions', sortable: false}               
            ];                    

            this.headersSubjects = [{text: 'Subjects', value: 'abbr', sortable:false}]
             
        },

        classMarkSheet () {
            this.overlay(true);
            this.$nextTick(() => {
                this.setExpandTerms(true);
            });

            this.setSrc({
                baseUrl: process.env.VUE_APP_API_URI  + '/api/mark-sheet',
                year: this.currentYear,
                term: this.currentTerm,
                classId: this.studentRecord.class_id,
                report: 'mark-sheet'               
            });

        },

        rankSheet () {            
            this.overlay(true);
            this.$nextTick(() => {
                this.setExpandTerms(true);
            });
            
            this.setSrc({
                baseUrl: process.env.VUE_APP_API_URI  + '/api/rank-sheet',
                year: this.currentYear,
                term: this.currentTerm,
                classId: this.studentRecord.class_id,
                report: 'rank-sheet'               
            });           
           
        },
        
        classStudentSubjects (item) {
            // console.log(item);            
            if(item.entered == 1) return "font-weight-bold primary--text";
            return "font-weight-bold red--text";
        },

        enterMarks () {
            if(this.admin){
                 Object.keys(this.menuOptions).forEach(key => {
                    this.menuOptions[key] = false;
                })
                this.menuOptions["enterMarks"] = true;
            }
            else{                
                this.setEnterMarks(true);
                this.setEditViewTermReports(false);
                this.setMarkSheetOverlay(true);                    
                this.setMarkSheetLoading(true); 
            }
        },

        closeEditViewTermReports () {
            this.setOverlay(true);
            this.setExpand(true);
        },

    }
}
</script>

<style scoped>    

    ::v-deep .v-input__slot{
        min-height: 0px !important;
        display: flex !important;
        align-items: center !important;
    }

    .v-btn__content{
        font-size: 0.8em;
    }

    ::v-deep .v-input__append-inner{
        margin-top: 0;
    }

    ::v-deep .v-select__selections{
        height: 30px;
        /*padding: 0 !important;*/
        padding-top: 2px !important;
        padding-bottom: 2px !important;
    }

    ::v-deep .v-text-field__slot input{
        text-align: center;
    }

    ::v-deep .v-text-field__slot textarea{
        line-height: 1rem;
        font-size: 0.7rem;
    }

    ::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
        padding: 0 6px;
        font-size: 0.7rem;
        text-align: center;
    }

    ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
        padding: 0 6px;
        font-size: 0.75rem;
    }

    ::v-deep .v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > td {
        height: 22px;
    }

    ::v-deep .v-data-table--dense > .v-data-table__wrapper > table > thead > tr > th {
        height: 22px;
    }

    ::v-deep textarea {
        padding-top: 8px;
    }

    ::v-deep .v-input input{
        height: 25px;
    }

    /* ::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot, .v-text-field.v-text-field--enclosed .v-text-field__details{
        padding: 0 5px;
    } */

    ::v-deep .change-class .v-input__icon{
        min-width: 10px;
        width: 10px;
    }

    ::v-deep .v-list-item__title{
        min-width: 100px;
    }

    ::v-deep .v-select.v-input--dense .v-select__selection--comma{
        width: 50px;
        text-align: center;
    }

    ::v-deep .v-textarea.v-text-field--enclosed textarea{
        margin-top: 5px;
    }

    ::v-deep #label-form-class{
        position: absolute;
        top: -15px;
        right: 0;
    }

    ::v-deep .v-text-field--filled .v-label--active {
        transform: translateY(-20px) scale(0.75);
    }

    /* Chrome, Safari, Edge, Opera */
    ::v-deep input::-webkit-outer-spin-button,
    ::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
    text-align:center
    }

    /* Firefox */
    ::v-deep input[type=number] {
    -moz-appearance: textfield;
    appearance: textfield;
    text-align: center;
    }

    ::v-deep th span{
        white-space: pre-wrap;
    }
</style>